var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1026_36918)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45063 5.85329L5.03437 3.26955L8.8966 7.13178L6.31286 9.71552C5.20965 10.8187 5.20965 12.6074 6.31286 13.7106C7.41606 14.8138 9.20471 14.8138 10.3079 13.7106L12.8917 11.1268L16.7539 14.9891L14.1701 17.5728C10.9339 20.8091 5.68688 20.8091 2.45063 17.5728C-0.785629 14.3366 -0.785623 9.08955 2.45063 5.85329Z",
    fill: "#FFD456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07076 0.209895C8.35062 -0.0699653 8.80436 -0.0699648 9.08422 0.209895L11.9648 3.09049C12.2447 3.37035 12.2447 3.8241 11.9648 4.10396L9.94031 6.12847L6.55298 2.74114C6.27312 2.46128 6.27312 2.00754 6.55298 1.72768L8.07076 0.209895Z",
    fill: "#FFD456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9065 8.04568C16.1864 7.76582 16.6402 7.76582 16.92 8.04568L19.7662 10.8919C20.046 11.1717 20.046 11.6255 19.7662 11.9053L17.7417 13.9298L13.882 10.0702L15.9065 8.04568Z",
    fill: "#FFD456"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1026_36918",
    x: 0.0234375,
    y: 0,
    width: 20.9526,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1026_36918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1026_36918",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnap);
export default __webpack_public_path__ + "static/media/snap.6876e1853347ca71f03195ea97f92677.svg";
export { ForwardRef as ReactComponent };